import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, AutoComplete, Input, Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import UpdateFieldsContent from './UpdateFieldsContent';
import styles from '../../index.less';

const { WorkFlow } = Enums;
const { UpdateFields } = WorkFlow;
const cx = classNames.bind(styles);

const AutoOption = AutoComplete.Option;

const defaultProps = {};
const propTypes = {
  triggerTypes: PropTypes.array.isRequired,
  actionValue: PropTypes.object.isRequired,
  workFlowId: PropTypes.string.isRequired,
  hadleSiderClose: PropTypes.func.isRequired
};

const TriggerActionsContent = ({
  triggerTypes,
  actionValue,
  workFlowId,
  hadleSiderClose
}) => {
  const { triggerValue } = actionValue;
  const { triggerType } = triggerValue;

  const getContent = () => {
    switch (triggerType) {
      case UpdateFields:
        return (
          <UpdateFieldsContent
            actionValue={actionValue}
            workFlowId={workFlowId}
            hadleSiderClose={hadleSiderClose}
          />
        );

      default:
        return null;
    }
  };

  const renderAutoCompleteOption = item => (
    <AutoOption
      key={item.value}
      value={item.value}
    >
      {item.display_label}
    </AutoOption>
  );

  const filterAutoOption = (inputValue, option) => option.props.children.toLowerCase().trim().indexOf(inputValue.toLowerCase().trim()) > -1;

  return (
    <React.Fragment>
      <Row gutter={8} className="mb-lg">
        <Col span={1} className={classNames(cx('workFlow-form-label'), cx('action-label'), 'text-right')}>
          <FormattedMessage id="page.WorkFlow.trigger" />
        </Col>
        <Col span={8}>
          <AutoComplete
            className="full-width"
            defaultValue={triggerType ? triggerType.toString() : ''}
            dataSource={triggerTypes && triggerTypes.map(renderAutoCompleteOption)}
            filterOption={filterAutoOption}
          >
            <Input suffix={<Icon type="search" />} />
          </AutoComplete>
        </Col>
      </Row>
      {getContent()}
    </React.Fragment>
  );
};

TriggerActionsContent.defaultProps = defaultProps;
TriggerActionsContent.propTypes = propTypes;

export default TriggerActionsContent;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/TriggerActions/TriggerActionsContent.jsx